export default class BudgetModel {
    constructor () {

        this.id = null
        this.client_id = null
        this.contact_id = null
        this.user_id = null
        this.opportunity_id = null
        this.billing_type = ""
        this.status = "Active"
        this.start_date = null
        this.yodiz_projects = []
        this.balance = null
        this.budget = null
        this.spent = null
    }
}
